module.exports = __webpack_public_path__ + "94af8c630f6abafb4ef2c9dee8e817a8.svg";